import { useEffect, useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { AppService } from '../services/app.service';

export const useNeoCmsFeatureRelatedGamesHook = (featureName) => {
    const gamesById = useSelector(state => state.casino.gamesById);
    const featureRelatedGameCategories = useSelector(
        state => state.app.featureRelatedGameCategories
    );
    const verticals = useSelector(state => state.app.verticals);
    const [featureRelatedGames, setFeatureRelatedGames] = useState([]);

    const gameIds = useMemo(() => {
        const categoryId = featureRelatedGameCategories?.[featureName] || 0;
        return AppService.getGameIdsByCategoryId(verticals, categoryId);
    }, [featureRelatedGameCategories, verticals, featureName]);

    useEffect(() => {
        const existingGames = gameIds.map(id => gamesById[id]).filter(Boolean);
        setFeatureRelatedGames(existingGames);
    }, [gameIds, gamesById]);

    return { featureRelatedGames };
};
